import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { cancelOrder } from "../../instantAnswers/orders-cancelOrder";
import { orderCanceledStateVisibilityFn } from "../../visibilityFunctions/orderStateVisibilityFn";
export var useOrderCanceledBrandNodes = function useOrderCanceledBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    WhyWasThisCanceledCanceledState: {
      id: "WhyWasThisCanceledCanceledState",
      label: strictLocalize({
        id: "BZTGML",
        defaultMessage: [{
          "type": 0,
          "value": "Waarom is dit geannuleerd?"
        }]
      }),
      level: 2,
      isNodeVisible: orderCanceledStateVisibilityFn,
      instantAnswer: cancelOrder(strictLocalize),
      articles: [articles.FulfillingOrders.UNDERSTAND_ORDER_STATUS, articles.FulfillingOrders.CAN_RETAILER_CANCEL_ORDER, articles.FulfillingOrders.FULFILLING_ORDER]
    },
    OtherCanceledState: {
      id: "OtherCanceledState",
      label: strictLocalize({
        id: "vPSjMz",
        defaultMessage: [{
          "type": 0,
          "value": "Anders"
        }]
      }),
      level: 2,
      isNodeVisible: orderCanceledStateVisibilityFn,
      articles: [articles.FulfillingOrders.FULFILLING_ORDER]
    }
  };
};